import type { OsNavItem } from './types';

export function matchesPath(path: string | undefined, currentPath: string): boolean {
  if (!path) return false;

  const base = path.split('?')[0];
  return currentPath === base || currentPath.startsWith(`${base}/`);
}

export interface NavItemState {
  activeChild?: OsNavItem;
  isActive: boolean;
  isCurrent: boolean;
}

export function navItemState(item: OsNavItem, currentPath: string): NavItemState {
  const activeChild = item.children?.find(child => matchesPath(child.path, currentPath));
  const isActive = !!activeChild || matchesPath(item.path, currentPath);

  return { activeChild, isActive, isCurrent: isActive && !activeChild };
}
